export const TrafficViolationsRequestType = {
    NoRequest: 0,
    AsPhysicalPerson: 1,
    AsCompany: 2
}